<template>
    <div class="h-100 d-flex align-items-center justify-content-center" v-on:click="onAction" :class="$safe(field,'EmployeeWorkingType.Color') ? ['type',$safe(field,'EmployeeWorkingType.Color')].join('-') : null">
        {{ $safe(field,'EmployeeWorkingType.Code') || '-' }}
    </div>
</template>

<script>
import moment from 'moment'
export default {
    props:{
        row:Object,
        field:[Object,String]
    },
    methods:{
        onAction(){
            this.$emit('action',this.$safe(this.row,'Employee'),moment(this.$safe(this.field,'Date')).format('DD.MM.YYYY'),this.$safe(this.field,'DriverScoreTaskId'),this.$safe(this.field,'EmployeeWorkingType.Id')||null)
        }
    },
}
</script>

<style>

</style>